<template>
  <div id="content">

    <div id="cont"
         class="center">
      <table class="table"
             id="infoTable"
             cellspacing="0">
        <tbody v-if="$i18n.locale=='en'">
          <tr>
            <td colspan="3"><strong>International Trade Department</strong></td>
          </tr>
          <tr>
            <td class="infoTitle">NAME</td>
            <td class="infoTitle">PHONE</td>
            <td class="infoTitle">E-MAIL</td>
          </tr>
          <tr v-for="c in ccontacts"
              :key="c.id">
            <td class="tdStyle">{{c.name_en}}</td>
            <td class="tdStyle">{{c.phone_en}}</td>
            <td class="tdStyle"><a :href="'mailto: '+c.email"> {{c.email}}</a></td>
          </tr>
          <tr>
            <td colspan="3"><strong>Domestic Trade Department</strong></td>
          </tr>
          <tr>
            <td class="infoTitle">NAME</td>
            <td class="infoTitle">PHONE</td>
            <td class="infoTitle">E-MAIL</td>
          </tr>
          <tr v-for="c in contacts"
              :key="c.id">
            <td class="tdStyle">{{c.name_en}}</td>
            <td class="tdStyle">{{c.phone_en}}</td>
            <td class="tdStyle"><a :href="'mailto: '+c.email"> {{c.email}}</a></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3"><strong>国际贸易部</strong></td>
          </tr>
          <tr>
            <td class="infoTitle">姓名</td>
            <td class="infoTitle">分机号码</td>
            <td class="infoTitle">邮箱</td>
          </tr>
          <tr v-for="big in ccontacts"
              :key="big.id">
            <td class="tdStyle">{{big.name}}</td>
            <td class="tdStyle">{{big.phone}}</td>
            <td class="tdStyle"><a :href="'mailto: '+big.email"> {{big.email}}</a></td>
          </tr>
          <tr>
            <td colspan="3"><strong>国内贸易部</strong></td>
          </tr>
          <tr>
            <td class="infoTitle">姓名</td>
            <td class="infoTitle">分机号码</td>
            <td class="infoTitle">邮箱</td>
          </tr>
          <tr v-for="big in contacts"
              :key="big.id">
            <td class="tdStyle">{{big.name}}</td>
            <td class="tdStyle">{{big.phone}}</td>
            <td class="tdStyle"><a :href="'mailto: '+big.email"> {{big.email}}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: 'About',
  data () {
    return {
      contacts: [],
      ccontacts: []
    };
  },
  mounted () {
    if (this.$route.params.id)
      this.id = this.$route.params.id
    // alert(this.$route.params.id);
    // 使用
    const params = { lang: 'china' }; // 参数
    fetch.post("/api/ApiContact/GetContactList", params).then(
      (res) => {
        this.contacts = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    const ps = { lang: 'english' }; // 参数
    fetch.post("/api/ApiContact/GetContactList", ps).then(
      (res) => {
        this.ccontacts = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  }
};
</script>

<style>
#about {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#cont {
  width: 1190px;
  margin: 20px auto auto;
}

#info {
  width: 880px;
  margin-left: 210px;
}
.center {
  width: 1300px;
  margin: 20px auto;
}
.center #infoTable .tdStyle {
  padding: 15px 0px;
  font-size: 14px;
  width: 298px;
  text-align: center;
  border-top: 1px solid #d0d0d0;
  vertical-align: middle;
}
.center #infoTable {
  border: 1px solid #0099cc;
}
.center #infoTable .infoTitle {
  border: none;
  background-color: #0099cc;
  font-size: 14px;
  color: white;
  padding: 0px;
  width: 298px;
  padding: 10px 0px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Contact.vue